const features = [
  {
    icon: 'ri-speed-line',
    title: '极速不缓冲',
    desc: '智能带宽适配引擎，根据网络环境自动优化画质，告别卡顿和缓冲等待，享受丝滑流畅的观影体验。',
    color: 'primary',
  },
  {
    icon: 'ri-4k-line',
    title: '超清画质',
    desc: '支持最高4K分辨率播放，画面清晰细腻色彩饱满，让每一帧都呈现影院级的视觉品质与沉浸感受。',
    color: 'accent',
  },
  {
    icon: 'ri-stack-line',
    title: '海量片库',
    desc: '每日更新200+部影片，聚合西瓜视频免费、丝瓜视频等平台资源，最新电视剧电影大全一站收录。',
    color: 'secondary',
  },
];

const colorMap: Record<string, { bg: string; text: string; iconBg: string }> = {
  primary: { bg: 'bg-primary-50', text: 'text-primary-600', iconBg: 'bg-primary-100' },
  accent: { bg: 'bg-accent-50', text: 'text-accent-600', iconBg: 'bg-accent-100' },
  secondary: { bg: 'bg-secondary-50', text: 'text-secondary-600', iconBg: 'bg-secondary-100' },
};

export default function FeaturesSection() {
  return (
    <section id="features" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            平台优势
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            为什么选择黑桃视频？三大核心优势为你揭晓
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 max-w-[960px] mx-auto">
          {features.map((item, i) => {
            const c = colorMap[item.color];
            return (
              <div
                key={i}
                className={`${c.bg} rounded-2xl p-6 md:p-8 text-center border border-background-200/60 hover:scale-[1.02] transition-transform duration-300 cursor-default`}
              >
                <div className={`w-14 h-14 rounded-2xl ${c.iconBg} flex items-center justify-center mx-auto mb-5`}>
                  <i className={`${item.icon} text-2xl ${c.text}`}></i>
                </div>
                <h3 className="text-lg font-medium text-foreground-900 mb-3">{item.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}